import { GameManual } from '../../types';

export const carcassonneLegacyManualStub: GameManual = {
  chapters: [],
  firstGameSteps: [],
};
